class Dialog {
	static stack = [];
	static popup = [];
	
	static Modal(id, title, size, affirmLabel, body) {
		let dialog = new Modal(id, title, size || MEDIUM);
		if (affirmLabel) {
			dialog.affirmLabel = affirmLabel;
		}
		if (body) {
			dialog.body = body;
		}
		return dialog;
	}

	static Popup(body, position, title) {
		let popup = new Popup(title);
		if (body) popup.body = body;
		if (position) popup.position = position;
		return popup;
	}
	
	static Inline(node, instance) {
		let mode;
		if (typeof instance === 'undefined') {
			Dialog.stack.shift();
			mode = 'editing-off';
		} else {
			Dialog.stack.unshift({
				affirm: instance.save.bind(instance), 
				dismiss: instance.cancel.bind(instance)
			});
			mode = 'editing-on';
		}
		node.className = node.className.replace(/(^|\s+)(editing-)(on|off)(?=$|\s+)/gm, '$1'+mode);
	}
	
	static Confirm(message, affirmLabel, onAffirm, onDismiss, warningId) {
		if (warningId && warningId & hiddenWarnings) {
			onAffirm();
			return;
		}
		
		let dialog = new ConfirmModal(warningId);
		dialog.body = UI.div('confirm-message', message);
		dialog.affirmLabel = affirmLabel;
		dialog.open(onAffirm, onDismiss);
	}
	
	static click() {
		for (let i = Dialog.popup.length - 1; 0 <= i; i--) {
			if (Dialog.popup[i].close()) Dialog.popup.splice(i,1);
		}
	}
	
	static keyup(event) {
		if (Dialog.stack.length === 0) return;
		if (event.keyCode === AC.ENTER_KEY) {
			Dialog.stack[0].affirm();
		} else if (event.keyCode === AC.ESCAPE_KEY) {
			Dialog.stack[0].dismiss();
		}
	}
	
	static makeToast() {}

	constructor () {
		this._title = null;
		this._elem = null;
	}
	
	set title(value) {
		this._title.style.display = value ? 'block':'none';
		this._title.innerHTML = value || '';
	}
	
	get body() {
		return this._bodyContent;
	}
	
	clear() {
		this._bodyContent.innerHTML = '';
		return this;
	}
	
	set body(value) {
		if (Array.isArray(value)) {
			value.forEach(v => this.body = v);
		} else if (typeof value === 'object') {
			this._bodyContent.appendChild(value);
		} else if (typeof value === 'string') {
			this._bodyContent.innerHTML += value;
		}
	}
}

const TINY = 'tiny', SMALL = 'small', MEDIUM = 'medium', LARGE = 'large', X_LARGE = 'x-large', CONFIRM = 'confirm';

class Modal extends Dialog {
	constructor(id, title, size) {
		super();
		this.id = id;
		this._title = UI.h1('text-xl');
		
		this._headContent = UI.div('');
		this._bodyContent = UI.div('dialog-content');
		this._footContent = UI.div();
		this._head = UI.div('dialog-head primary-color', [
			this._title,
			this._headContent
		]);
		
		this._affirmButton = btn('ed-sec-btn ms-2');
		this._affirmButton.id = this.id + '-aff-btn';
		this._affirmButton.style.display = 'none';
		onEv(this._affirmButton, 'click', this.affirm.bind(this));
		
		this._dismissButton = btn('ed-sec-btn ms-2', _("DONE"));
		this._dismissButton.id = this.id + '-dis-btn';
		onEv(this._dismissButton, 'click', this.dismiss.bind(this));
		
		this._size = size;
		this._elem = null;
		
		this._onAffirm = null;
		this._onDismiss = null;
		
		this.title = title;
		this._autoClose = true;
	}
	
	get elem() {
		if (this._elem !== null) return this._elem;

		this._elem = UI.div('dialog-mask hide', [
			UI.div('dialog-box dialog-' + this._size, [
				this._head,
				UI.div('dialog-body', [
					UI.div('dialog-content-wrapper', [
						this._bodyContent,
						UI.div('loading-dialog', '<div><div class="spinner"></div></div>')
					])
				]),
				UI.div('flex justify-between dialog-foot secondary-color', [
					UI.div('flex justify-between', [
						this._footContent,
						UI.div('', [
							this._dismissButton,
							this._affirmButton
						])
					])
				])
			], null, { 'id': this.id + '-box' })
		]);
		document.body.appendChild(this._elem);
		document.dispatchEvent(new Event('tipsAdded'));
		return this._elem;
	}
	
	set title(value) {
		super.title =value;

		this._head.style.display 
			= this._title.innerHTML == '' && this._headContent.innerHTML == ''
			? 'none':'block';
	}
	
	set head(value) {
		if (Array.isArray(value)) {
			value.forEach(v => this.head = v);
		} else if (value === null) {
			this._headContent.innerHTML = '';
		} else if (typeof value === 'object') {
			this._headContent.appendChild(value);
		} else if (typeof value === 'string') {
			this._headContent.innerHTML += value;
		} 
		
		this._head.style.display 
			= this._title.innerHTML == '' && this._headContent.innerHTML == ''
			? 'none':'block';
	}
	
	set foot(value) {
		if (value === null) {
			this._footContent.innerHTML = '';
		} else if (typeof value === 'object') {
			this._footContent.appendChild(value);
		} else if (typeof value === 'string') {
			this._footContent.innerHTML += value;
		}
	}
	
	set affirmLabel(value) {
		this._affirmButton.innerHTML = value ? value : '';
		this._dismissButton.innerHTML = value ? _("CANCEL") : _("DONE");
	}
	
	get affirmButton() {
		return this._affirmButton;
	}
	
	set dismissLabel(value) {
		this._dismissButton.innerHTML = value ? value : _("DONE");
	}
	
	set onAffirm(value) {
		this._onAffirm = typeof value === 'function' ? value : null;
		this._affirmButton.style.display 
			= this._affirmButton.innerHTML === '' || this._onAffirm === null 
			? 'none':'inline-block';
	}
	
	set onDismiss(value) {
		this._onDismiss = typeof value === 'function' ? value : null;
	}
	
	set autoClose(v) {
		this._autoClose = v;
	}
	
	affirm() {
		if (this.affirmButton.disabled) return;
		if (this._onAffirm !== null) {
			if (this._autoClose) this.close();
			this._onAffirm.apply(null, arguments);
		}
	}
	
	dismiss() {
		this.close();
		if (this._onDismiss !== null) this._onDismiss.apply(null, arguments);
	}
	
	open(onAffirm, onDismiss, autoClose) {
		if (typeof autoClose !== 'undefined') this.autoClose = autoClose;
		
		if (onAffirm) this.onAffirm = onAffirm;
		if (onDismiss) this.onDismiss = onDismiss;
		if (Dialog.stack.length && Dialog.stack[0].elem) {
			state(Dialog.stack[0].elem, 'hide');
		}
		state(this.elem);
		Dialog.stack.unshift(this);
		document.activeElement.blur();
		return this;
	}
	
	loading() {
		state(this.elem, 'loading');
	}
	
	useReply(reply) {
		let result = false;
		if (reply.html){
			this.clear().body = reply.html;
			result = true;
		}
		if (reply.body){
			this.clear().body = reply.body;
			result = true;
		}
		if (reply.foot) {
			this.leftFoot = reply.foot;
			result = true;
		}
		this.ready();
		return result;
	}
	
	ready() {
		state(this.elem);
	}
	
	close() {
		state(this.elem, 'hide');
		Dialog.stack.shift();
		if (Dialog.stack.length && Dialog.stack[0].elem) {
			state(Dialog.stack[0].elem);
		}
	}

	dispose() {
		this.elem.remove()
	}
}

class ConfirmModal extends Modal {
	constructor(warningId) {
		super('confirm'+warningId, '', 'confirm');
		this.elem.classList.add('confirm');
		this._warningId = warningId || null;
		this._notAgain = chk();
		if (this._warningId) {
			super.foot = label(null, [
				this._notAgain,
				span(null, _("Don't show this message again"))
			]);
		}
	}
	
	affirm() {
		this.close();
		if (this._onAffirm !== null) this._onAffirm();
		if (this._notAgain.checked) {
            hiddenWarnings += this._warningId;
			API.update(`users/warnings/${this._warningId}`);
		}
	}
	
	close() {
		super.close();
		super.dispose();
	}
}

class Popup extends Dialog {
	constructor(title) {
		super();
		this._title = UI.div('title');
		this._bodyContent = UI.div();
		this.position = 'below';
		
		this._elem = UI.div(
			'popup-dialog',
			[
				this._title,
				this._bodyContent
			],
			null,
			this.id == null ? null :
			{
				'id': this.id+'-popup'
			}
		);
		this._onHide = null;
		this._holdOpen = false;
		this._alignedTo = false;
		
		this.title = title;
		document.body.appendChild(this._elem);
	}
	
	set onHide(value) {
		this._onHide = typeof value === 'function' ? value : null;
	}
	
	get itemValue() {
		return this._alignedTo.value || null;
	}
	
	sticky() {
		onEv(this._elem, 'click', () => this._holdOpen = true);
		// onEv(this._elem, 'click', (event) => stopEv(event));
		return this;
	}
	
	handle(alignTo, event) {
		if (alignTo === this._alignedTo) return;

		if (!this._alignedTo) Dialog.popup.push(this);
		this._alignedTo = alignTo;
		this._holdOpen = true;

		this.reposition();
	}

	reposition() {
		if (!this._alignedTo) return;
		let pos = findPos(this.position, this._elem, this._alignedTo, 5);
		this._elem.style.top = pos.top + 'px';
		this._elem.style.left = pos.left + 'px';
	}
	
	close() {
		if (this._holdOpen) {
			this._holdOpen = false;
			return false;
		}
		
		if (this._onHide !== null) this._onHide();
		this._elem.style.left = '-9999px';
		this._alignedTo = false;
		return true;
	}
}